<template>
  <div class="wrapper">
    <div class="detail-header">
      <span class="detail-title">{{ templateName }}</span>
      <el-button size="small" @click="$router.back()">关闭</el-button>
    </div>

    <div class="header-search">
      <el-form ref="form" inline :model="searchData" label-width="">
        <el-form-item :label="modelLabel">
          <el-select
            style="width: 200px"
            v-model="searchData.model"
            placeholder="请选择"
            size="small"
            clearable
          >
            <el-option
              v-for="item in modelList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select
            style="width: 200px"
            v-model="searchData.status"
            placeholder="请选择"
            size="small"
            clearable
          >
            <el-option label="上架" :value="1" />
            <el-option label="下架" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label=" ">
          <el-button type="primary" size="small" icon="el-icon-search" @click="applySearch(true)">搜索</el-button>
          <el-button type="info" size="small" icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <tp-table
      :tableData="list"
      :columns="columns"
      :totalNum="total"
      :current-page.sync="currentPage"
      :pageSize.sync="pageSize"
    />

    <!-- 修改监管机回收价 -->
    <el-dialog
      title="修改监管机回收价"
      :visible.sync="recyclePriceDialog"
      width="500px"
    >
      <el-form ref="recyclePriceForm" :model="recyclePriceForm" label-width="130px">
        <el-form-item label="原监管机回收价：" prop="originRecyclePrice">
          {{ recyclePriceForm.originRecyclePrice }}
        </el-form-item>
        <el-form-item label="新监管机回收价：" prop="recyclePrice">
          <el-input v-model="recyclePriceForm.recyclePrice" placeholder="请输入监管机回收价"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="recyclePriceDialog = false">取消</el-button>
        <el-button type="primary" @click="submitRecyclePrice">确定</el-button>
      </div>
    </el-dialog>

    <!-- 编辑商品价格 -->
    <el-dialog
      title="编辑商品"
      :visible.sync="editDialogVisible"
      width="600px"
      @opened="openEditDialog"
    >
      <el-form ref="editForm" :model="editForm" label-width="120px">
        <el-form-item v-if="goodsType === 1" label="原始官网价" prop="originOfficialPrice" :rules="editRules">
          <el-input-number
            style="width: 320px"
            size="small"
            v-model="editForm.originOfficialPrice"
            :precision="2"
            :step="0.01"
            :min="0"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="官网价" prop="officialPrice" :rules="editRules">
          <el-input-number
            style="width: 320px"
            size="small"
            v-model="editForm.officialPrice"
            :precision="2"
            :step="0.01"
            :min="0"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="全新售价" prop="minPrice" :rules="editFreshPriceRules">
          <div>
            <el-input-number
              style="width: 150px"
              size="small"
              v-model="editForm.minPrice"
              :precision="2"
              :step="0.01"
              :min="0"
            ></el-input-number>
            ~
            <el-input-number
              style="width: 150px"
              size="small"
              v-model="editForm.maxPrice"
              :precision="2"
              :step="0.01"
              :min="0"
            ></el-input-number>
          </div>
        </el-form-item>
        <el-form-item v-if="goodsType === 1" label="二手售价" prop="oldMinPrice" :rules="editOldPriceRules">
          <div>
            <el-input-number
              style="width: 150px"
              size="small"
              v-model="editForm.oldMinPrice"
              :precision="2"
              :step="0.01"
              :min="0"
            ></el-input-number>
            ~
            <el-input-number
              style="width: 150px"
              size="small"
              v-model="editForm.oldMaxPrice"
              :precision="2"
              :step="0.01"
              :min="0"
            ></el-input-number>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEdit">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { authBtnMixin } from "@/mixins/authBtnMixin";
import { getAttrListAPI } from "@/views/store/store-goods/api.js";
import { getTemplateGoodsPage, editTemplateRecyclePriceAPI, editTemplateGoodsStatusAPI, editTemplateGoodsAPI } from "./api.js";

function getColumns(goodsType) {
  const idCol = {
    label: "ID", prop: "goodsId", minWidth: "80",
    customRender(h, row) { return <p>{row["goodsId"]}</p>; },
  };
  const modelCol = {
    label: "型号", prop: "modelName", minWidth: goodsType === 1 ? "120" : "150",
    customRender(h, row) { return <p>{row["modelName"]}</p>; },
  };
  const memoryCol = {
    label: "内存", prop: "memoryName", minWidth: "120",
    customRender(h, row) { return <p>{row["memoryName"]}</p>; },
  };
  const colorCol = {
    label: "颜色", prop: "colorNames", minWidth: "150",
    customRender(h, row) { return <p>{row["colorNames"]}</p>; },
  };
  const originPriceCol = {
    label: "原始官网价", prop: "originOfficialPrice", minWidth: "120",
    customRender(h, row) { return <p>{row["originOfficialPrice"]}</p>; },
  };
  const officialPriceCol = {
    label: "官网价", prop: "officialPrice", minWidth: "120",
    customRender(h, row) { return <p>{row["officialPrice"]}</p>; },
  };
  // const buyoutPriceCol = {
  //   label: "买断金", prop: "buyoutPrice", minWidth: "120",
  //   customRender(h, row) { return <p>{row["buyoutPrice"]}</p>; },
  // };
  const freshPriceCol = {
    label: "全新价格区间",
    prop: "minPrice", minWidth: "160",
    customRender(h, row) { return <p>{row["minPrice"]} ~ {row["maxPrice"]}</p>; },
  };
  // const profitAprCol = {
  //   label: "全新年化收益率", prop: "profitApr", minWidth: "130",
  //   customRender(h, row) { return <p>{row["profitApr"] ? row["profitApr"] + '%' : '-'}</p>; },
  // };
  const oldPriceCol = {
    label: "二手价格区间", prop: "oldMinPrice", minWidth: "160",
    customRender(h, row) { return <p>{row["oldMinPrice"]} ~ {row["oldMaxPrice"]}</p>; },
  };
  // const oldProfitAprCol = {
  //   label: "二手年化收益率", prop: "oldProfitApr", minWidth: "130",
  //   customRender(h, row) { return <p>{row["oldProfitApr"] ? row["oldProfitApr"] + '%' : '-'}</p>; },
  // };
  const recyclePriceCol = {
    label: "监管机回收价", prop: "recyclePrice", minWidth: "120",
    customRender(h, row) {
      return (
        <div>
          <span>{row["recyclePrice"] || "-"}</span>
          <i
            class="el-icon-edit"
            onClick={() => this.editRecyclePrice(row)}
            style="margin-left: 5px; cursor: pointer; color: #409eff"
            title="修改监管机回收价"
          ></i>
        </div>
      );
    },
  };
  // const weightCol = {
  //   label: "权重", prop: "weight", minWidth: "90",
  //   customRender(h, row) { return <p>{row["weight"]}</p>; },
  // };
  const coverCol = {
    label: "封面", prop: "coverImageUrl", minWidth: "120",
    customRender(h, row) {
      return (
        <p>
          <el-image
            style="width: 60px; height: 60px;display:block;margin:5px 0;border-radius:5px"
            src={row["coverImageUrl"]}
            preview-src-list={[row["coverImageUrl"]]}
          ></el-image>
        </p>
      );
    },
  };
  const statusCol = {
    label: "状态", prop: "status", minWidth: "120",
    customRender(h, row) {
      return (
        <div>
          <el-switch
            class="switch"
            onChange={() => this.changeStatus(row)}
            v-model={row["status"]}
            active-value={true}
            inactive-value={false}
            active-text="上架"
            inactive-text="下架"
          ></el-switch>
        </div>
      );
    },
  };
  const actionCol = {
    label: "操作", minWidth: goodsType === 1 ? "180" : "200", fixed: "right",
    customRender(h, row) {
      return (
        <div>
          <el-link
            style="margin-left:10px;"
            disabled={row["status"]}
            underline={false}
            type="primary"
            onClick={() => this.handleEdit(row)}
          >
            编辑
          </el-link>
        </div>
      );
    },
  };

  if (goodsType === 1) {
    return [
      idCol, modelCol, memoryCol, colorCol, originPriceCol,
      officialPriceCol, freshPriceCol,
      oldPriceCol, recyclePriceCol,
      coverCol, statusCol, actionCol,
    ];
  }
  return [
    idCol, modelCol, colorCol, officialPriceCol,
    freshPriceCol,
    coverCol, statusCol, actionCol,
  ];
}

export default {
  name: "StoreGoodsPriceTemplateDetail",
  mixins: [authBtnMixin],
  data() {
    return {
      templateName: "",
      goodsType: 1,
      columns: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        model: "",
        status: "",
      },
      modelList: [],
      editDialogVisible: false,
      editRules: [{ required: true, message: "该项不能为空", trigger: "blur" }],
      editFreshPriceRules: [
        { required: true, message: "该项不能为空", trigger: "blur" },
        { validator: this.validateEditFreshPrice, trigger: "change" },
      ],
      editOldPriceRules: [
        { required: true, message: "该项不能为空", trigger: "blur" },
        { validator: this.validateEditOldPrice, trigger: "change" },
      ],
      editForm: {
        relId: null,
        originOfficialPrice: "",
        officialPrice: "",
        minPrice: "",
        maxPrice: "",
        oldMinPrice: "",
        oldMaxPrice: "",
      },
      recyclePriceDialog: false,
      recyclePriceForm: {
        relId: undefined,
        originRecyclePrice: "",
        recyclePrice: "",
      },
    };
  },
  computed: {
    modelLabel() {
      return this.goodsType === 1 ? "机型" : "车型";
    },
  },
  provide() {
    return {
      context: this,
    };
  },
  watch: {
    currentPage() {
      this.getList();
    },
    pageSize() {
      this.getList();
    },
  },
  mounted() {
    this.templateName = this.$route.query.name || "模板详情";
    this.goodsType = Number(this.$route.query.goodsType) || 1;
    this.columns = getColumns(this.goodsType);
    this.getModelList();
    this.getList();
  },
  methods: {
    // 获取模板商品详情列表
    async getList() {
      const { model, status } = this.searchData;
      const res = await getTemplateGoodsPage({
        tplId: this.$route.query.tplId,
        model,
        status,
        page: this.currentPage,
        pageSize: this.pageSize,
      });
      // 模板信息
      if (res.tplName) {
        this.templateName = res.tplName;
        this.goodsType = res.goodsType;
      }
      this.list = res.list || [];
      this.total = res.total || 0;
    },
    async getModelList() {
      const res = await getAttrListAPI({
        goodsType: this.goodsType,
        groupCode: "model",
      });
      this.modelList = (res || []).map((item) => ({
        label: item.enumText,
        value: item.enumCode,
      }));
    },
    applySearch(resetPage = false) {
      if (resetPage && this.currentPage !== 1) {
        this.currentPage = 1;
        return;
      }
      this.getList();
    },
    reset() {
      this.searchData = { model: "", status: "" };
      this.applySearch(true);
    },
    // 编辑商品价格
    handleEdit(row) {
      this.editForm = {
        relId: row.relId,
        originOfficialPrice: row.originOfficialPrice || "",
        officialPrice: row.officialPrice || "",
        minPrice: row.minPrice || "",
        maxPrice: row.maxPrice || "",
        oldMinPrice: row.oldMinPrice || "",
        oldMaxPrice: row.oldMaxPrice || "",
      };
      this.editDialogVisible = true;
    },
    openEditDialog() {
      this.$refs.editForm?.clearValidate();
    },
    validateEditFreshPrice(rule, value, callback) {
      const { minPrice, maxPrice } = this.editForm;
      if (minPrice !== "" && maxPrice !== "" && Number(minPrice) > Number(maxPrice)) {
        callback(new Error("最高价不能低于最低价"));
      } else {
        callback();
      }
    },
    validateEditOldPrice(rule, value, callback) {
      const { oldMinPrice, oldMaxPrice } = this.editForm;
      if (oldMinPrice !== "" && oldMaxPrice !== "" && Number(oldMinPrice) > Number(oldMaxPrice)) {
        callback(new Error("最高价不能低于最低价"));
      } else {
        callback();
      }
    },
    submitEdit() {
      this.$refs.editForm.validate(async (valid) => {
        if (!valid) return;
        try {
          await editTemplateGoodsAPI(this.editForm);
            this.$message.success("编辑成功");
            this.editDialogVisible = false;
            this.getList();
        } catch (error) {
          this.$message.error("编辑失败");
        }
      });
    },
    editRecyclePrice(row) {
      this.recyclePriceForm.relId = row.relId;
      this.recyclePriceForm.originRecyclePrice = row.recyclePrice;
      this.recyclePriceForm.recyclePrice = "";
      this.recyclePriceDialog = true;
    },
    submitRecyclePrice() {
      this.$refs.recyclePriceForm.validate(async (valid) => {
        if (valid) {
          try {
            await editTemplateRecyclePriceAPI({
              relId: this.recyclePriceForm.relId,
              recyclePrice: this.recyclePriceForm.recyclePrice,
            });
            this.getList();
            this.$message.success("修改成功");
            this.recyclePriceDialog = false;
          } catch (error) {
            this.$message.error("修改失败");
          }
        }
      });
    },
    changeStatus(row) {
      let { relId, status } = row;
      let data = { relId, status: status == false ? 0 : 1 };
      let statusDesc = status == 0 ? "下架" : "上架";

      this.$confirm(`此操作将${statusDesc}该商品, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          row.status = status == false ? false : true;
          editTemplateGoodsStatusAPI(data).then(() => {
            this.getList();
            this.$message.success("操作成功");
          });
        })
        .catch(() => {
          row.status = status == true ? false : true;
          this.$message({ type: "info", message: "已取消操作" });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 20px;
  border-bottom: 1px solid #ebeef5;

  .detail-title {
    font-size: 18px;
    font-weight: 600;
    color: #303133;
  }
}

.header-search {
  margin-top: 20px;

  .el-form-item {
    margin-right: 35px;
  }
}

.tp-table {
  .el-table__fixed-right {
    height: 100% !important;
  }
}
</style>
<style lang="scss" scoped>
.wrapper /deep/ {
  /* switch按钮样式 */
  .switch .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
  }
  .switch .el-switch__label--right {
    z-index: 1;
  }
  .switch .el-switch__label--right span {
    margin-left: 5px;
    margin-right: 10px;
  }
  .switch .el-switch__label--left {
    z-index: 1;
  }
  .switch .el-switch__label--left span {
    margin-left: 20px;
  }
  .switch .el-switch__label.is-active {
    display: block;
  }
  .switch.el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 55px !important;
    margin: 0;
  }
}
</style>
